import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import Box from '../Box';
import {
  addLowerContentItem,
  removeLowerContentItem
} from '../../../../../../../Redux/slices/certificate';

function LowerContent({ preview }) {
  const dispatch = useDispatch();
  const lowerContent = useSelector((state) => state.certificate.lowerContent);
  const { lowerContentList } = lowerContent;

  const [showOptions, setShowOptions] = useState(false);
  const [showCloseId, setShowCloseId] = useState(false);

  const isLowerContentListEmpty = lowerContentList.length < 1;

  const handleShowOptions = () => {
    if (!preview) {
      setShowOptions(true);
    }
  };

  return (
    <div
      className={`overflow-hidden position-relative w-100 d-flex justify-content-${
        lowerContentList.length === 1 ? 'around' : 'between'
      } align-items-center mt-4 
      ${preview ? '' : 'c-container'}
      `}
      style={{ minHeight: '200px' }}
      onMouseEnter={handleShowOptions}
      onMouseLeave={() => setShowOptions(false)}>
      {showOptions && lowerContentList.length < 4 && (
        <div
          key="modal"
          initial={{ x: 150 }}
          animate={{ x: 0 }}
          exit={{ x: 150 }}
          transition={{ x: { duration: 0.3 } }}
          className="d-flex border "
          style={{
            position: 'absolute',
            right: 0,
            top: 0,
            minHeight: '100%',
            minWidth: '150px',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '10px 0',
            background: 'rgba(255, 255, 255,0.9)',
            zIndex: 2
          }}>
          <div>
            <Button
              variant="primary"
              onClick={() => {
                dispatch(addLowerContentItem());
              }}>
              + Add
            </Button>
          </div>
        </div>
      )}

      {isLowerContentListEmpty ? (
        <div className="w-100 text-center hidden-in-print">Hover to add Signatures or Images</div>
      ) : (
        <>
          {lowerContentList.map((lowerContent, index) => {
            return (
              <div
                key={index}
                className="position-relative overflow-hidden bg-white"
                onMouseEnter={() => !preview && setShowCloseId(index)}
                onMouseLeave={() => setShowCloseId(false)}
                style={{
                  zIndex: showCloseId === index ? 3 : 1
                }}>
                <Box boxContent={lowerContent} key={index} index={index} preview={preview} />
                {showCloseId === index && (
                  <div
                    initial={{ x: 150 }}
                    animate={{ x: 0 }}
                    exit={{ x: 150 }}
                    transition={{ x: { duration: 0.15 } }}
                    style={{
                      position: 'absolute',
                      right: 0,
                      top: 0,
                      background: 'rgba(255, 255, 255,0.9)'
                    }}>
                    <Button
                      variant="outline-danger"
                      onClick={() => {
                        dispatch(removeLowerContentItem(index));
                      }}>
                      <AiOutlineCloseCircle fontSize="32px" />
                    </Button>
                  </div>
                )}
              </div>
            );
          })}
        </>
      )}
    </div>
  );
}

export default LowerContent;
